<template>
  <div class="list-session-item">
    <v-hover close-delay='250' v-slot:default='{hover}'>
      <v-card :class='`transition-fast-in-fast-out pl-${hover ? 12 : 0}`'>
        <v-list-item :key='name'>
          <v-layout wrap>
            <v-tooltip top>
              <template v-slot:activator='{on}' v-if="type === '3x3'"><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/333.png'></v-list-item-avatar></template>
              <template v-else-if="type === '3BLD'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/333bld.png'></v-list-item-avatar></template>
              <template v-else-if="type === '3x3OH'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/333oh.png'></v-list-item-avatar></template>
              <template v-else-if="type === '2x2'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/222.png'></v-list-item-avatar></template>
              <template v-else-if="type === '4x4'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/444.png'></v-list-item-avatar></template>
              <template v-else-if="type === '5x5'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/555.png'></v-list-item-avatar></template>
              <template v-else-if="type === '6x6'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/666.png'></v-list-item-avatar></template>
              <template v-else-if="type === '7x7'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/777.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'Megaminx'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/minx.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'Pyraminx'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/pyram.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'Clock'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/clock.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'Skewb'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/skewb.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'Square-1'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/sq1.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'FTO'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/fto.png'></v-list-item-avatar></template>
              <template v-else v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../assets/invalid.png'></v-list-item-avatar></template>
              <span>{{ type }}</span>
            </v-tooltip>
            <v-flex xs9 sm4>
              <v-list-item-content>
                <v-list-item-title>{{ name }}</v-list-item-title>
                <v-list-item-subtitle>Creator: {{ creator }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-flex>
            <v-flex xs6 sm3>
              <v-text-field v-if='!existingAuthToken' v-model='password' placeholder='Password' type='password'></v-text-field>
              <v-text-field v-else v-model='password' placeholder='Password (not required)' type='password'></v-text-field>
            </v-flex>
            <v-flex xs6 sm2>
              <v-btn-toggle rounded>
                <v-btn text outlined @click='enterSession' style='border-color: unset !important'>Enter Session</v-btn>
                <v-btn v-if='spectatorMode' text outlined @click='spectateSession' style='border-color: unset !important'>Spectate</v-btn>
                <v-btn v-if='source === "user_page"' text outlined @click='archiveSession' style='border-color: unset !important; color: red;'>Archive</v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
        </v-list-item>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import UsersService from '@/services/UsersService'

export default {
  name: 'list-session-item',
  data () {
    return {
      password: ''
    }
  },
  methods: {
    async spectateSession () {
      this.$router.push({ path: `/session/${this.id}/spectate`, params: { id: this.id } })
    },
    async archiveSession () {
      let confirmation = confirm('Once archived, a session will not appear at the top of the page. You will find it below in the archived sessions list. Continue?')
      if (!confirmation) return
      let response = await UsersService.archiveSession({
        globalAuthToken: this.$store.state.globalAuthToken,
        solverId: this.$store.state.solverId,
        sessionId: this.id,
      })
      if (response.data.error) {
        alert('Error: ' + response.data.error)
      } else if (response.data.success) {
        alert('Successfully archived session. You can find this session below in your archived list once you refresh this page.')
      }
    },
    async enterSession () {
      if (!this.validateUserInput()) {
        return
      }

      if (this.$store.state.globalAuthToken !== '') {
        // user is logged in
        let authToken = this.existingAuthToken
        let password = this.password
        var response = await UsersService.getSessionToken({
          globalAuthToken: this.$store.state.globalAuthToken,
          solverId: this.$store.state.solverId,
          solver: this.$store.state.solver,
          sessionId: this.id,
          ...authToken && {authToken},
          ...password && {password}
        })
        if (response.data.error) {
          if (response.data.error === 'badPassword') {
            // wrong password
            alert('Wrong password')
          } else if (response.data.error === 'badAuthToken') {
            // wrong or missing auth token
            alert('Failed authentication')
          } else if (response.data.error === 'badLoginAuth') {
            // globalAuthToken failed in ensureAuthenticated
            alert("Your login didn't work. Try logging out and logging in again.")
          } else if (response.data.error === 'DBerror') {
            // mongoDB save failed
            alert('Database error. Try again later.')
          } else {
            // miscellaneous error
            alert('Hmmm... Something went wrong and I have no idea what caused it. Yikes.')
          }
          this.$router.push({ path: '/' })
          return
        }
        localStorage.setItem('globalAuthToken', this.$store.state.globalAuthToken)
        localStorage.setItem('globalSolver', this.$store.state.solver)
        localStorage.setItem('solverId:' + this.id, this.$store.state.solverId)
        localStorage.setItem('token:' + this.id, response.data.authToken)

        if (this.$route.path === `/session/${this.id}`) {
          this.$router.go()
        } else {
          this.$router.push({ path: `/session/${this.id}`, params: { id: this.id } })
        }
      } else {
        alert('Must be logged in to enter session')
      }
    },
    // TODO: improve input validation (eg. no trailing spaces, only readable text, no html or xss)
    validateUserInput () {
      // ensure there is a password, or the user has logged in previously and the authToken is stored locally
      if (this.password === '' && !this.existingAuthToken) {
        alert('Password is required for initial log in')
        return false
      }
      return true
    }
  },
  computed: {
    existingAuthToken () {
      if (this.$store.state.solverId === localStorage.getItem('solverId:' + this.id)) {
        return localStorage.getItem('token:' + this.id)
      }
      return undefined
    }
  },
  props: {
    name: String,
    creator: String,
    type: String,
    id: String,
    spectatorMode: Boolean,
    source: String,
  }
}
</script>

<style scoped>
.v-list__tile {
  height: 88px;
}
.v-list-item__content {
  text-align: left;
}
@media only screen and (max-width: 1080px) {
  .v-list__tile {
    height: 150px
  }
}
</style>
